import "./Contact.css";
import { v4 as uuidv4 } from "uuid";
import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'



const Contact = () => {
  const [contactDates, setContactDates] = useState({
    id: " ",
    name: "",
    email: "",
    message: "",
    Phone: " ",
    city:"",
    Country:"",
    state:""
  });

  const [emptyInputs, setEmptyInputs] = useState(false);

  const form = useRef();

  // me guarda lo del input  en la variable valor del mismo input

  const onChangeInput = (e) => {
    setContactDates({
      ...contactDates,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmitInput = (e) => {
    // que no recargue la pagina
    e.preventDefault();
    // validacion
    //validar que no este vacio

    if (
      contactDates.name === "" ||
      contactDates.email === "" ||
      contactDates.message === "" ||
      contactDates.Phone === " "
    ) {
      setEmptyInputs(true);
     
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Form whit input empty',
        })

    } else {
      emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_USER_ID);
      emailjs
        .sendForm(
          process.env.REACT_APP_EMAILJS_SERVICE_ID,
          process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
          form.current
        )
        .then(
          (result) => {
            console.log(result.text);
          },
          (error) => {
            console.log("error");
          }
        );

        Swal.fire(
          "¡success!",
          "It has been send successfully"


          )
  
    }

    setContactDates({
      id: " ",
      name: "",
      email: "",
      message: "",
      Phone: " ",
      city:"",
      Country:"",
      state:""
    });
  };

  //send data

  return (
    <form className="form" onSubmit={onSubmitInput} ref={form}>
      <h1>Contact with me</h1>

      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon2">
          Name
        </span>
        <input
          type="text"
          class="form-control"
          placeholder="Name  "
          aria-describedby="basic-addon2"
          required
          name="name"
          onChange={onChangeInput}
        />
      </div>

      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon2">
          Email
        </span>
        <input
          name="email"
          type="email"
          class="form-control"
          placeholder="Email"
          aria-describedby="basic-addon2"
          required
          onChange={onChangeInput}
        />
      </div>
      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon2">
          Country
        </span>
        <input
          name="Country"
          type="text"
          class="form-control"
          placeholder="Country "
          aria-describedby="basic-addon2"
          required
          onChange={onChangeInput}
        />
      </div>

      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon2">
          State
        </span>
        <input
          name="state"
          type="text"
          class="form-control"
          placeholder="State"
          aria-describedby="basic-addon2"
          required
          onChange={onChangeInput}
        />
      </div>

      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon2">
          City
        </span>
        <input
          name="city"
          type="text"
          class="form-control"
          placeholder="City "
          aria-describedby="basic-addon2"
          required
          onChange={onChangeInput}
        />
      </div>

      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon2">
          Phone Number
        </span>
        <input
          name="Phone"
          type="number"
          class="form-control"
          placeholder=" Phone Number "
          aria-describedby="basic-addon2"
          required
          onChange={onChangeInput}
        />
      </div>

      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon2">
          Message:
        </span>
        <textarea
          name="message"
          class="form-control"
          rows="10"
          cols="100"
          placeholder="Message"
          aria-describedby="basic-addon2"
          required
          onChange={onChangeInput}
        ></textarea>
      </div>

      <button
        onClick={onSubmitInput}
        class="btn btn-success m-2 mb-2"
        type="button"
      >
        Send Information
      </button>
      <button class="btn btn-danger  m-2 mb-5" type="reset">
        Cancel
      </button>
    </form>
  );
};

export default Contact;
